import { useCallback, useContext } from 'react'
import { getAuth } from 'firebase/auth'
import AuthContext from '../../context/AuthContext'
import ApiContext from '../../context/ApiContext'

export type ToggleUserSeatParams = {
	userId: string
	disabled: boolean
	isChargeApproved?: boolean
}

const useToggleUserSeat = () => {
	const authContext = useContext(AuthContext)
	const apiContext = useContext(ApiContext)
	const auth = getAuth()

	const toggleUserSeat = useCallback(
		async (params: ToggleUserSeatParams): Promise<void> => {
			const { userId, disabled, isChargeApproved = false } = params
			const idToken = await auth.currentUser?.getIdToken(true)
			const response = await fetch(
				`${apiContext.apiUrl}/companies/${authContext.company?.id}/users/toggle-disabled`,
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${idToken}`,
					},
					body: JSON.stringify({ userId, disabled, isChargeApproved }),
				},
			)
			if (response.status === 402) {
				const error = (await response.json()) as {
					code: string
					message: string
					extraSeatsRequired?: number
				}
				throw error
			}
			if (!response.ok) {
				const text = await response.text()
				let body: { code?: string; message?: string }
				try {
					body = JSON.parse(text) as { code?: string; message?: string }
				} catch {
					throw new Error(text)
				}
				if (body.code) throw body
				throw new Error(body.message ?? text)
			}
		},
		[apiContext.apiUrl, auth.currentUser, authContext.company?.id],
	)

	return { toggleUserSeat }
}

export default useToggleUserSeat
